<template>
  <div class="wrapper">
    <el-steps :active="0" finish-status="success">
      <el-step title="上传文件"></el-step>
      <el-step title="等待审核"></el-step>
      <el-step title="审核通过"></el-step>
      <el-step title="预约面试"></el-step>
    </el-steps>
    <div class="upload">
      <el-upload
        :http-request="paperFileUpload"
        drag
        :headers="{ Authorization: getStore('accessToken'), accountId: 1 }"
        action="#"
        :src="uploadData.paperUrl"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em> <br />
          支持文件格式：.pdf ，单个文件不能超过10M
        </div>
      </el-upload>
    </div>
    <div class="selectBar">
      <h3>论文分组:&emsp;</h3>
      <el-select
        v-model="uploadData.paperGroupId"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in paperGroupList"
          :key="item.paperGroupName"
          :label="item.paperGroupName"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="submitBar">
      <el-button type="primary" @click="thesisUpload()">提交</el-button>
    </div>
  </div>
</template>
<script>
import {
  editPaperSetting,
  getPaperGroupList,
  thesisUpload,
  paperIsExist,
} from "@/api/paper.js";

export default {
  data() {
    return {
      uploadData: {
        paperGroupId: "",
        paperName: "",
        paperUrl: "",
        userId: 50,
      },
      paperGroupList: [],
    };
  },
  created() {},
  mounted() {
    this.getPaperGroupList();
  },
  methods: {
    getPaperGroupList() {
      getPaperGroupList({ source: 0 }).then((data) => {
        console.log("paperApplyListPro结果", data);
        this.paperGroupList = data;
      });
    },

    paperFileUpload({ file }) {
      paperIsExist(this.uploadData).then(() => {
        this.$oss
          .put("/paperPdf/" + file.uid + file.name, file)
          .then((data) => {
            console.log(data);
            this.uploadData.paperUrl = data.url;
            this.uploadData.paperName = data.name
              .match(/[\u4e00-\u9fa5]/g)
              .join("");
            this.$message.success("上传成功");
          })
          .catch((err) => {
            console.error(data.message());
          });
      });
    },

    thesisUpload() {
      console.log("要提交的data", this.form);
      thesisUpload(this.uploadData).then(() => {
        this.$message.success("保存成功");
        this.goTo("myThesis");
      });
    },

    goTo(url) {
      this.$router.push({ name: url });
    },

    // uploadBg(e) {
    //   console.log("上传", e.file);
    //   this.$oss
    //       .put(e.file.uid + "." + e.file.type.split("/")[1], e.file)
    //       .then((data) => {
    //         console.log(data);
    //         this.bgData.myBg = data.url;
    //         this.applyData.image = data.url;
    //       });
    // },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  padding: 20px;

  .el-steps {
    padding: 20px 100px;
  }

  .upload {
    display: flex;
    justify-content: center;
    padding-top: 50px;
  }

  .selectBar {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }

  .submitBar {
    display: flex;
    justify-content: center;
    padding-left: 45%;
  }
}
</style>